import React from "react";

import DataGrid, {
  Editing,
  Selection,
  FilterRow,
  Pager,
  Paging,
  Column,
  Grouping,
  RowDragging,
} from "devextreme-react/data-grid";
export default function ScreenSettingTable({ dataSource = [] }) {
  const SCREEN_CODE_DATA = [
    "P0001",
    "P0002",
    "P0003",
    "P0004",
    "P0005",
    "P0006",
    "P0007",
    "P0008",
    "P0009",
    "P0010",
    "P0011",
    "P0012",
    "P0013",
    "P0014",
    "P0015",
    "P0016",
    "P0017",
    "P0018",
    "P0019",
    "P0020",
    "P0021",
    "P0022",
    "P0023",
    "P0024",
    "P0025",
    "P0026",
    "P0027",
    "P0028",
    "P0029",
    "P0030",
    "P0031",
    "P0032",
    "P0033",
    "P0034",
    "P0035",
    "P0036",
    "P0037",
    "P0038",
    "P0039",
    "P0040",
    "P0041",
    "P0042",
    "P0043",
    "P0044",
    "P0045",
    "P0046",
    "P0047",
    "P0048",
    "P0049",
    "P0050",
    "P0051",
    "P0052",
    "P0053",
    "P0054",
    "P0055",
    "P0056",
    "P0057",
    "P0058",
    "P0059",
    "P0060",
    "P0061",
    "P0062",
    "P0063",
    "P0064",
    "P0065",
    "P0066",
    "P0067",
    "P0068",
    "P0069",
  ];

  const onReorder = (e) => {
    // reordering then save to database with DataSource

    const dataSource = e.component.getDataSource();
    const items = dataSource.items();
    const item = items[e.fromIndex];
    items.splice(e.fromIndex, 1);
    items.splice(e.toIndex, 0, item);

    // console.log(item)
    dataSource.store().update(item.Oid, item);
  };
  return (
    <>
      <DataGrid
        dataSource={dataSource}
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
      >
        <Grouping autoExpandAll={true} />
        <RowDragging
          allowReordering={true}
          onReorder={onReorder}
          showDragIcons={true}
        />
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={20} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />

        <Editing
          mode="batch"
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}
          // useIcons={true}
        />
        <Column
          dataField="ScreenCode"
          caption="Screen Code"
          groupIndex={0}
          lookup={{
            // From P0001 to P0069
            dataSource: SCREEN_CODE_DATA,
            allowSearch: true,
          }}
        />
        <Column dataField="Caption" caption="Caption" />
        <Column dataField="DataField" caption="DataField" />
        <Column
          dataField="DataType"
          caption="DataType"
          lookup={{
            dataSource: ["string", "number", "boolean"],
            allowSearch: true,
            allowClearing: true,
          }}
        />
        <Column
          dataField="VisibleIndex"
          caption="Visible Index"
          dataType="number"
        />
        <Column dataField="Visible" caption="Visible" dataType="boolean" />
        <Column
          dataField="Alignment"
          caption="Alignment"
          lookup={{
            dataSource: ["left", "center", "right"],
            allowSearch: true,
            allowClearing: true,
          }}
        />
        <Column dataField="Fixed" caption="Fixed" dataType="boolean" />
        <Column
          dataField="FixedPosition"
          caption="Fixed Position"
          lookup={{
            dataSource: ["left", "right"],
            allowSearch: true,
            allowClearing: true,
          }}
        />
        <Column
          dataField="Format"
          caption="Format"
          lookup={{
            dataSource: ["dd/MM/yyyy", "dd/MM/yyyy HH:mm", "HH:mm"],
            allowSearch: true,
            allowClearing: true,
          }}
        />
        <Column
          dataField="HidingPriority"
          caption="Hiding Priority"
          sortKey="priority"
          dataType="boolean"
        />

        <Column dataField="Width" caption="Width" dataType="number" />
        <Column dataField="Remarks" caption="Remarks" />
      </DataGrid>
    </>
  );
}
